// FieldConfig.js

export class FieldConfig {
  constructor(key, label, placeholder = "", priority = 1, type = 'input', visibility = 'Readonly', IsVisible = true, place = '',mandatory, PagePermission = 'disable') {
    this.key = key;
    this.label = label;
    this.placeholder = placeholder;
    this.priority = priority;
    this.type = type;
    this.visibility = visibility;
    this.IsVisible = IsVisible;
    this.PagePermission = PagePermission;
    this.place = place;
    this.mandatory = mandatory;


  }
  // Method to update visibility based on API response
  setVisibility(isVisible) {
    this.isVisible = isVisible;
  }
}

export const PurchaseEntryFields = [
  new FieldConfig("customerName", "Firm Name", "", 1, "inputselect", "ReadWrite", true, "top"),
  new FieldConfig("addsupplier", "Add Supplier", "", 1, "Button", "ReadOnly", true, "top"),
  new FieldConfig("toplotnumber", "Lot Number", "", 1, "text", "ReadOnly", true, "top"),
  new FieldConfig("findgole", "Fine Gold", "", 1, "text", "ReadOnly", true, "top"),
  new FieldConfig("findsilver", "Fine Silver", "", 1, "text", "ReadOnly", true, "top"),
  new FieldConfig("advanceamount", "Advance Amount", "", 1, "text", "ReadOnly", true, "top"),
  new FieldConfig("balanceamount", "Balance Amount", "", 1, "text", "ReadOnly", true, "top"),



  new FieldConfig("StockKeepingUnit", "Enter Sku", "", 1, "inputselect", "ReadWrite", true, "middle"),
  new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadOnly", true, "middle"),
  new FieldConfig("ProductId", "Product", "", 1, "dropdown", "ReadOnly", true, "middle"),
  new FieldConfig("PurityId", "Purity", "", 1, "dropdown", "ReadOnly", true, "middle"),
  new FieldConfig("DesignId", "Design", "", 1, "dropdown", "ReadOnly", true, "middle"),

  // new FieldConfig("CategoryName", "CategoryName", "", 1, "dropdown", "ReadOnly", false, "middle"),
  // new FieldConfig("ProductName", "ProductName", "", 1, "dropdown", "ReadOnly", false, "middle"),
  // new FieldConfig("PurityName", "PurityName", "", 1, "dropdown", "ReadOnly", false, "middle"),
  // new FieldConfig("DesignName", "DesignName", "", 1, "dropdown", "ReadOnly", false, "middle"),



  new FieldConfig("TotalWt", "Total Wt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("PackingWt", "Packing Wt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("GrossWt", "Gross Wt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("StoneWt", "Stone Wt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("ClipWeight", "Clip Wt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("ClipQuantity", "Clip Qty", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("NetWt", "Net Wt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("FinePercent", "Fine%", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("WastagePercent", "Wastage%", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("Quantity", "Qty", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("StonePieces", "Stone Pcs", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("MakingPerGram", "Making/GRM", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("MakingFixedWastage", "Fixed Wastage", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("MakingFixedAmt", "Fixed Amt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("MakingPercentage", "Making%", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("MetalRate", "Rate/Gm", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("StoneAmount", "Stone Amt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("HallmarkAmt", "Hallmark", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("TagWeight", "Tag Wt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("FindingWeight", "Finding Wt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("LanyardWeight", "Lanyard Wt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("ItemAmt", "Item Amt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("MakingAmt", "Making Amt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("TotalItemAmt", "Total Item Amt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("FineWt", "Fine Wt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("FineWastageWt", "FineWastage", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("WastageWt", "Wastage Wt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("Testing", "Testing", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("AddToUnlabelled", "Add to unlabel", "", 1, "checkbox", "ReadOnly", true, "middle"),

  new FieldConfig("DiamondName", "Diamond Name", "", 1, "text", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondAmount", "Diamond Amount", "", 1, "number", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondPieces", "Diamond Pcs", "", 1, "number", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondWeight", "Diamond Wt", "", 1, "number", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondRate", "Diamond Rate", "", 1, "number", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondSize", "Diamond Size", "", 1, "number", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondPurchaseRate", "D Purchase Rate", "", 1, "number", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondSellRate", "D Sell Rate", "", 1, "number", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondClarity", "D Clarity", "", 1, "text", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondColour", "D Colour", "", 1, "text", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondShape", "D Shape", "", 1, "text", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondCut", "D Cut", "", 1, "text", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondSettingType", "D SettingType", "", 1, "text", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondPurchaseAmount", "D Purchase Amt", "", 1, "number", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondSellAmount", "D Sell Amt", "", 1, "number", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondDescription", "D Description", "", 1, "text", "ReadOnly", false, "middle"),
  new FieldConfig("StoneButton", "Stones", "", 1, "popupbutton", "ReadOnly", false, "middle"),
  new FieldConfig("DiamondButton", "Diamonds", "", 1, "popupbutton", "ReadOnly", false, "middle"),
];


export const PurchaseEntryNewFields = [
//top section 
  new FieldConfig("VendorName", "Vendor Name", "", 1, "searchDropdown", "ReadWrite", true, "top",true),
  new FieldConfig("TotalFineGold", "Fine Gold", "", 1, "text", "ReadOnly", true, "top",false),
  new FieldConfig("TotalFineSilver", "Fine Silver", "", 1, "text", "ReadOnly", true, "top",false),
  new FieldConfig("advanceamount", "Advance Amount", "", 1, "text", "ReadOnly", true, "top",false),
  new FieldConfig("balanceamount", "Balance Amount", "", 1, "text", "ReadOnly", true, "top",false),


  // middle section 
  new FieldConfig("StockKeepingUnit", "Enter Sku", "", 1, "dropdown", "ReadWrite", true, "middle",false),
  new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  new FieldConfig("ProductId", "Product", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  new FieldConfig("DesignId", "Design", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  new FieldConfig("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  new FieldConfig("TotalWt", "Total Wt", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("PackingWeight", "Packing Wt", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("GrossWt", "Gross Wt", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("StoneWt", "Stone Wt", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("DiamondWeight", "Diamond Wt", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("NetWt", "Net Wt", "", 1, "number", "ReadOnly", true, "middle",false),
  new FieldConfig("Qty", "Qty", "", 1, "number", "ReadWrite", true, "middle",true),
  new FieldConfig("Pieces", "Pieces", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("MetalRate", "Rate/Gm", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("FinePercent", "Fine%", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("WastagePercent", "Wastage%", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("MakingPerGram", "Making/Gm", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("MakingFixedWastage", "Fixed Wastage", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("MakingFixedAmt", "Fix Amount", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("StonePieces", "Stone Pcs", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("StoneAmount", "Stone Amt", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("Hallmark", "Hallmark ", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("ClipQty", "Clip Qty", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("ClipWt", "Clip Wt", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("TagWt", "Tag Wt", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("FindingWt", "Finding Wt", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("LanyardWt", "Lanyard Wt", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("PouchWt", "Pouch Wt", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("MetalAmount", "Metal Amount", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("TotalMakingAmount", "T. Making Amount", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("TotalItemAmount", "T. Item Amount", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("FineWt", "Fine Wt", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("WastageWt", "Wastage Wt", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("FineWastageWt", "Fine + Wastage Wt", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("Testing", "Testing", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("images", "Images", "", 1, "popup", "ReadWrite", true, "middle",false),
  new FieldConfig("Stone", "Add Stone", "", 1, "popup", "ReadWrite", true, "middle",false),
  new FieldConfig("Diamond", "Add Diamond", "", 1, "popup", "ReadWrite", true, "middle",false),



 
  // new FieldConfig("DiamondPurchaseRate", "D Purchase Rate", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondSellRate", "D Sell Rate", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondPurchaseAmount", "D Purchase Amt", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondSellAmount", "D Sell Amt", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("StoneButton", "Stones", "", 1, "popupbutton", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondButton", "Diamonds", "", 1, "popupbutton", "ReadOnly", false, "middle"),
];


export const PurchaseEntryLooseDiamondNewFields =  [
  //top section 
  new FieldConfig("VendorName", "Vendor Name", "", 1, "searchDropdown", "ReadWrite", true, "top",true),
  new FieldConfig("TotalFineGold", "Fine Gold", "", 1, "text", "ReadOnly", true, "top",false),
  new FieldConfig("TotalFineSilver", "Fine Silver", "", 1, "text", "ReadOnly", true, "top",false),
  new FieldConfig("advanceamount", "Advance Amount", "", 1, "text", "ReadOnly", true, "top",false),
  new FieldConfig("balanceamount", "Balance Amount", "", 1, "text", "ReadOnly", true, "top",false),

 // middle section
 new FieldConfig("StockKeepingUnit", "Enter Sku", "", 1, "searchDropdown", "ReadWrite", true, "middle",false),
 new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  // new FieldConfig("DiamondName", "Name", "", 1, "text", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondName", "Diamond Name", "", 1, "dropdown", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondShape", "Diamond Shape", "", 1, "dropdown", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondColour", "Colour", "", 1, "dropdown", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondClarity", "Clarity", "", 1, "dropdown", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondSleve", "Sleve", "", 1, "dropdown", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondSize", "Size", "", 1, "dropdown", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondSleveGroup", "Sleve Group", "", 1, "dropdown", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondWeight", "Weight", "", 1, "number", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondPieces", "Pieces", "", 1, "number", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondRate", "Rate", "", 1, "number", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondAmount", "Amount", "", 1, "number", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondCut", "Diamond Cut", "", 1, "dropdown", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondSettingType", "Setting Type", "", 1, "dropdown", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondCertificate", "Certificate", "", 1, "text", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondPacket", "Packet", "", 1, "text", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondBox", "Box", "", 1, "text", "ReadWrite", false, "middle",false),
  new FieldConfig("DiamondDescription", "Description", "", 1, "text", "ReadWrite", false, "middle",false),
  // new FieldConfig("DiamondPurchaseRate", "D Purchase Rate", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondSellRate", "D Sell Rate", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondPurchaseAmount", "D Purchase Amt", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondSellAmount", "D Sell Amt", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("StoneButton", "Stones", "", 1, "popupbutton", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondButton", "Diamonds", "", 1, "popupbutton", "ReadOnly", false, "middle"),
];
export const PurchaseEntryLooseStoneNewFields =  [
  //top section 
  new FieldConfig("VendorName", "Vendor Name", "", 1, "searchDropdown", "ReadWrite", true, "top",true),
  new FieldConfig("TotalFineGold", "Fine Gold", "", 1, "text", "ReadOnly", true, "top",false),
  new FieldConfig("TotalFineSilver", "Fine Silver", "", 1, "text", "ReadOnly", true, "top",false),
  new FieldConfig("advanceamount", "Advance Amount", "", 1, "text", "ReadOnly", true, "top",false),
  new FieldConfig("balanceamount", "Balance Amount", "", 1, "text", "ReadOnly", true, "top",false),

 // middle section
 new FieldConfig("StockKeepingUnit", "Enter Sku", "", 1, "searchDropdown", "ReadWrite", true, "middle",false),
 new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", true, "middle",true),
 new FieldConfig("StoneName", "Name", "", 1, "text", "ReadWrite", false, "middle",false),
 new FieldConfig("StoneShape", "Stone Shape", "", 1, "dropdown", "ReadWrite", false, "middle",false),
 new FieldConfig("StoneColour", "Colour", "", 1, "dropdown", "ReadWrite", false, "middle",false),
 new FieldConfig("StoneSize", "Size", "", 1, "number", "ReadWrite", false, "middle",false),
 new FieldConfig("StoneWeight", "Weight", "", 1, "number", "ReadWrite", false, "middle",false),
 new FieldConfig("StoneRateCt", "Rate/(ct/gr)", "", 1, "number", "ReadWrite", false, "middle",false),
 new FieldConfig("StonePieces", "Pieces", "", 1, "number", "ReadWrite", false, "middle",false),
 new FieldConfig("StoneRatePc", "Rate/Pc", "", 1, "number", "ReadWrite", false, "middle",false),
 new FieldConfig("StoneAmount", "Amount", "", 1, "number", "ReadWrite", false, "middle",false),
 new FieldConfig("StoneSettingType", "Setting Type", "", 1, "dropdown", "ReadWrite", false, "middle",false),
 new FieldConfig("StoneCertificate", "Certificate", "", 1, "text", "ReadWrite", false, "middle",false),
 new FieldConfig("StonePacket", "Packet", "", 1, "text", "ReadWrite", false, "middle",false),
  new FieldConfig("Box", "Box", "", 1, "text", "ReadWrite", false, "middle",false),
 new FieldConfig("StoneDescription", "Description", "", 1, "text", "ReadWrite", false, "middle",false),


];

export const InvoiceEntryNewFields = [
  //top section
  new FieldConfig("customerName", "Customer Name", "", 1, "searchDropdown", "ReadWrite", true, "top",true),
  new FieldConfig("Mobile", "Mobile", "", 1, "number", "ReadOnly", true, "top"),
  new FieldConfig("TotalFineGold", "Fine Gold", "", 1, "text", "ReadOnly", true, "top"),
  new FieldConfig("advanceamount", "Advance Amount", "", 1, "text", "ReadOnly", true, "top"),
  new FieldConfig("balanceamount", "Balance Amount", "", 1, "text", "ReadOnly", true, "top"),
  // middle section 
  new FieldConfig("StockKeepingUnit", "Enter Sku", "", 1, "searchDropdown", "ReadWrite", true, "middle"),
  new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  new FieldConfig("ProductId", "Product", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  new FieldConfig("DesignId", "Design", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  new FieldConfig("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  new FieldConfig("TotalWt", "Total Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("PackingWeight", "Packing Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("GrossWt", "Gross Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("StoneWt", "Stone Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("DiamondWeight", "Diamond Wt", "", 1, "number", "ReadWrite", true, "middle"),

  new FieldConfig("NetWt", "Net Wt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("Qty", "Quantity", "", 1, "number", "ReadWrite", true, "middle",true),
  new FieldConfig("Pieces", "Pieces", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("GoldRate", "Rate/Gm", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("FinePercent", "Fine%", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MakingPercent", "Making %", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MakingPerGram", "Making/Gm", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MakingFixedWastage", "Fixed Wastage", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MakingFixedAmt", "Fixed Amount", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("StonePieces", "Stone Pcs", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("StoneAmount", "Stone Amount", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("Hallmark", "Hallmark ", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MetalAmount", "Metal Amount", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("TotalMakingAmount", "T. Making Amount", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("TotalItemAmount", "T. Item Amount", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("FineWt", "Fine Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("WastageWt", "Wastage Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("FineWastageWt", "Fine + Wastage Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("CuttingGrossWt", "Cut Gross Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("CuttingNetWt", "Cut Net Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MRP", "MRP", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("Stone", "Add Stone", "", 1, "popup", "ReadWrite", true, "middle",false),
  // new FieldConfig("Diamond", "Add Diamond", "", 1, "popup", "ReadWrite", true, "middle",false),

  

  
];


export const QuotationEntryNewFields = [
  //top section
  new FieldConfig("customerName", "Customer Name", "", 1, "searchDropdown", "ReadWrite", true, "top",true),
  new FieldConfig("Mobile", "Mobile", "", 1, "number", "ReadOnly", true, "top"),
  new FieldConfig("TotalFineGold", "Fine Gold", "", 1, "text", "ReadOnly", true, "top"),
  new FieldConfig("advanceamount", "Advance Amount", "", 1, "text", "ReadOnly", true, "top"),
  new FieldConfig("balanceamount", "Balance Amount", "", 1, "text", "ReadOnly", true, "top"),
  // middle section 
  new FieldConfig("StockKeepingUnit", "Enter Sku", "", 1, "searchDropdown", "ReadWrite", true, "middle"),
  new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  new FieldConfig("ProductId", "Product", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  new FieldConfig("DesignId", "Design", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  new FieldConfig("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  new FieldConfig("TotalWt", "Total Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("PackingWeight", "Packing Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("GrossWt", "Gross Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("StoneWt", "Stone Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("DiamondWeight", "Diamond Wt", "", 1, "number", "ReadWrite", true, "middle"),

  new FieldConfig("NetWt", "Net Wt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("Qty", "Quantity", "", 1, "number", "ReadWrite", true, "middle",true),
  new FieldConfig("Pieces", "Pieces", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("GoldRate", "Rate/Gm", "", 1, "number", "ReadWrite", true, "middle",false),
  new FieldConfig("FinePercent", "Fine%", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MakingPercent", "Making %", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MakingPerGram", "Making/Gm", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MakingFixedWastage", "Fixed Wastage", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MakingFixedAmt", "Fixed Amount", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("StonePieces", "Stone Pcs", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("StoneAmount", "Stone Amount", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("Hallmark", "Hallmark ", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MetalAmount", "Metal Amount", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("TotalMakingAmount", "T. Making Amount", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("TotalItemAmount", "T. Item Amount", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("FineWt", "Fine Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("WastageWt", "Wastage Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("FineWastageWt", "Fine + Wastage Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("CuttingGrossWt", "Cut Gross Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("CuttingNetWt", "Cut Net Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MRP", "MRP", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("Stone", "Add Stone", "", 1, "popup", "ReadWrite", true, "middle",false),
  // new FieldConfig("Diamond", "Add Diamond", "", 1, "popup", "ReadWrite", true, "middle",false),

  

  
];





export const RepairEntryNewFields = [
  //top section
  new FieldConfig("customerName", "Customer Name", "", 1, "searchDropdown", "ReadWrite", true, "top",true),
  new FieldConfig("Mobile", "Mobile", "", 1, "number", "ReadOnly", true, "top"),
  new FieldConfig("TotalFineGold", "Fine Gold", "", 1, "text", "ReadOnly", true, "top"),
  new FieldConfig("advanceamount", "Advance Amount", "", 1, "text", "ReadOnly", true, "top"),
  new FieldConfig("balanceamount", "Balance Amount", "", 1, "text", "ReadOnly", true, "top"),
  // middle section 
  new FieldConfig("StockKeepingUnit", "Enter Sku", "", 1, "searchDropdown", "ReadWrite", true, "middle"),
  new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  new FieldConfig("ProductId", "Product", "", 1, "dropdown", "ReadWrite", true, "middle",true),
  new FieldConfig("DesignId", "Design", "", 1, "dropdown", "ReadWrite", true, "middle",false),
  new FieldConfig("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", true, "middle",false),
  new FieldConfig("TotalWt", "Total Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("PackingWeight", "Packing Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("GrossWt", "Gross Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("StoneWt", "Stone Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("DiamondWeight", "Diamond Wt", "", 1, "number", "ReadWrite", true, "middle"),

  new FieldConfig("NetWt", "Net Wt", "", 1, "number", "ReadOnly", true, "middle"),
  new FieldConfig("Qty", "Quantity", "", 1, "number", "ReadWrite", true, "middle",false),
  // new FieldConfig("Pieces", "Pieces", "", 1, "number", "ReadWrite", true, "middle",false),
  // new FieldConfig("GoldRate", "Rate/Gm", "", 1, "number", "ReadWrite", true, "middle",false),
  // new FieldConfig("FinePercent", "Fine%", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("MakingPercent", "Making %", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("MakingPerGram", "Making/Gm", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("MakingFixedWastage", "Fixed Wastage", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("MakingFixedAmt", "Fixed Amount", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("StonePieces", "Stone Pcs", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("StoneAmount", "Stone Amount", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("Hallmark", "Hallmark ", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("MetalAmount", "Metal Amount", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("TotalMakingAmount", "T. Making Amount", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("TotalItemAmount", "T. Item Amount", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("FineWt", "Fine Wt", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("WastageWt", "Wastage Wt", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("FineWastageWt", "Fine + Wastage Wt", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("CuttingGrossWt", "Cut Gross Wt", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("CuttingNetWt", "Cut Net Wt", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("MRP", "MRP", "", 1, "number", "ReadWrite", true, "middle"),
  // new FieldConfig("Stone", "Add Stone", "", 1, "popup", "ReadWrite", true, "middle",false),
  // new FieldConfig("Diamond", "Add Diamond", "", 1, "popup", "ReadWrite", true, "middle",false),

  

  
];

export const OldGoldInvoiceEntryNewFields = [
 
    //top section
    new FieldConfig("customerName", "Customer Name", "", 1, "searchDropdown", "ReadWrite", true, "top"),
    new FieldConfig("Mobile", "Mobile", "", 1, "number", "ReadOnly", true, "top"),
    new FieldConfig("TotalFineGold", "Fine Gold", "", 1, "text", "ReadOnly", true, "top"),
    new FieldConfig("advanceamount", "Advance Amount", "", 1, "text", "ReadOnly", true, "top"),
    new FieldConfig("balanceamount", "Balance Amount", "", 1, "text", "ReadOnly", true, "top"),
    // middle section 
    // new FieldConfig("StockKeepingUnit", "Enter Sku", "", 1, "searchDropdown", "ReadWrite", true, "middle"),
    new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", true, "middle",true),
    new FieldConfig("ProductId", "Product", "", 1, "dropdown", "ReadWrite", true, "middle",true),
    new FieldConfig("Qty", "Quantity", "", 1, "number", "ReadWrite", true, "middle"),
    new FieldConfig("TotalWt", "Total Wt", "", 1, "number", "ReadWrite", true, "middle"),
    new FieldConfig("PackingWeight", "Packing Wt", "", 1, "number", "ReadWrite", true, "middle"),
    new FieldConfig("GrossWt", "Gross Wt", "", 1, "number", "ReadWrite", true, "middle"),
    new FieldConfig("StoneWt", "Stone Wt", "", 1, "number", "ReadWrite", true, "middle"),
    new FieldConfig("NetWt", "Net Wt", "", 1, "number", "ReadWrite", true, "middle"),
    new FieldConfig("FinePercent", "Fine%", "", 1, "number", "ReadWrite", true, "middle"),
    new FieldConfig("FineWt", "Fine Wt", "", 1, "number", "ReadWrite", true, "middle"),
    new FieldConfig("GoldRate", "Rate/Gm", "", 1, "number", "ReadWrite", true, "middle",false),
    new FieldConfig("Amount", "Amount", "", 1, "number", "ReadWrite", true, "middle"),


  
]
export const WholesaleEntryNewFields = [
  //top section
  new FieldConfig("VendorName", "Customer Name", "", 1, "searchDropdown", "ReadWrite", true, "top"),
  new FieldConfig("Mobile", "Mobile", "", 1, "number", "ReadWrite", true, "top"),
  new FieldConfig("TotalFineGold", "Fine Gold", "", 1, "text", "ReadWrite", true, "top"),
  new FieldConfig("advanceamount", "Advance Amount", "", 1, "text", "ReadOnly", true, "top"),
  new FieldConfig("balanceamount", "Balance Amount", "", 1, "text", "ReadOnly", true, "top"),
  // middle section 
  // new FieldConfig("StockKeepingUnit", "Enter Sku", "", 1, "dropdown", "ReadOnly", true, "middle"),
  new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadOnly", true, "middle"),
  new FieldConfig("ProductId", "Product", "", 1, "dropdown", "ReadWrite", true, "middle"),
  // new FieldConfig("DesignId", "Design", "", 1, "dropdown", "ReadWrite", true, "middle"),
  new FieldConfig("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", true, "middle"),
  new FieldConfig("GrossWt", "Gross wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("NetWt", "Net Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("StoneWt", "Stone Wt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("StoneAmount", "Stone Amount", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MRP", "MRP", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("Hallmark", "Hallmark ", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("Making", "Making ", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MakingFixedAmt", "Making Fixed Amt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MakingPercent", "Making %", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MakingPerGram", "Making/GRM", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("MakingFixedWastage", "Making Fixed Wastage", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("GoldRate", "Gold Rate", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("NetAmount", "Net Amt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("GSTAmount", "GST Amt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("TotalAmount", "Total Amt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("Qty", "Quantity", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("FinePercent", "Fine%", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("FinalPrice", "FinalPrice", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("TotalGST", "Total GST", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("Purchase", "Purchase", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("UnlabeledId", "Unlabeled Id", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("CovertAmount", "Convert Amt", "", 1, "number", "ReadWrite", true, "middle"),
  new FieldConfig("Category", "Category", "", 1, "number", "ReadWrite", true, "middle"),
  

  // new FieldConfig("MakingPercentage", "Making%", "", 1, "number", "ReadOnly", true, "middle"),
  // new FieldConfig("StoneAmount", "Stone Amt", "", 1, "number", "ReadOnly", true, "middle"),
  // new FieldConfig("HallmarkAmt", "Hallmark", "", 1, "number", "ReadOnly", true, "middle"),
  // new FieldConfig("TagWeight", "Tag Wt", "", 1, "number", "ReadOnly", true, "middle"),
  // new FieldConfig("FindingWeight", "Finding Wt", "", 1, "number", "ReadOnly", true, "middle"),
  // new FieldConfig("LanyardWeight", "Lanyard wt", "", 1, "number", "ReadOnly", true, "middle"),
  // new FieldConfig("ItemAmt", "Item Amt", "", 1, "number", "ReadOnly", true, "middle"),
  // new FieldConfig("MakingAmt", "Making Amt", "", 1, "number", "ReadOnly", true, "middle"),
  // new FieldConfig("TotalItemAmt", "Total Item Amt", "", 1, "number", "ReadOnly", true, "middle"),
  // new FieldConfig("AddToUnlabelled", "Add to unlabel", "", 1, "checkbox", "ReadOnly", true, "middle"),

  // new FieldConfig("DiamondName", "Diamond Name", "", 1, "text", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondAmount", "Diamond Amount", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondPieces", "Diamond Pcs", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondWeight", "Diamond wt", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondRate", "Diamond Rate", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondSize", "Diamond Size", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondPurchaseRate", "D Purchase Rate", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondSellRate", "D Sell Rate", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondClarity", "D Clarity", "", 1, "text", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondColour", "D Colour", "", 1, "text", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondShape", "D Shape", "", 1, "text", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondCut", "D Cut", "", 1, "text", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondSettingType", "D SettingType", "", 1, "text", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondPurchaseAmount", "D Purchase Amt", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondSellAmount", "D Sell Amt", "", 1, "number", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondDescription", "D Description", "", 1, "text", "ReadOnly", false, "middle"),
  // new FieldConfig("StoneButton", "Stones", "", 1, "popupbutton", "ReadOnly", false, "middle"),
  // new FieldConfig("DiamondButton", "Diamonds", "", 1, "popupbutton", "ReadOnly", false, "middle"),
];








